"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMycotoxin = void 0;
var R = __importStar(require("ramda"));
var React = __importStar(require("react"));
var utils_1 = require("../../../utils");
var PanelCard_1 = __importDefault(require("../../PanelCard"));
var ResultsTable_1 = __importDefault(require("../../ResultsTable"));
var index_1 = require("../index");
var columns_1 = require("./columns");
exports.isMycotoxin = R.includes(R.__, index_1.MYCOTOXINS_LIST);
var referenceComponentRawNameLens = R.lensPath([
    "referenceComponent",
    "rawName",
]);
var filterNonMycotoxins = R.filter(R.pipe(R.view(referenceComponentRawNameLens), exports.isMycotoxin));
var filterMycotoxins = R.filter(R.pipe(R.view(referenceComponentRawNameLens), exports.isMycotoxin, R.not));
var determineChemResPassFailResult = R.pipe(R.map(index_1.determineRowPassFail("analyte")), R.ifElse(R.none(R.equals("Fail")), utils_1.upperCasePass, utils_1.upperCaseFail));
var CHEMICAL_RESIDUE_ROW_SPLIT = 35;
var ChemicalResidueCard = function (_a) {
    var result = _a.result, stateRegulations = _a.stateRegulations, moistureContentPercentage = _a.moistureContentPercentage, density = _a.density, isSolid = _a.isSolid, amountPerPackage = _a.amountPerPackage, amountPerServing = _a.amountPerServing, rest = __rest(_a, ["result", "stateRegulations", "moistureContentPercentage", "density", "isSolid", "amountPerPackage", "amountPerServing"]);
    var mycotoxinRows = utils_1.defaultBuildRows({
        parameters: filterNonMycotoxins(result.instrumentUsed.instrumentParameters).filter(function (_a) {
            var panel = _a.panel;
            return panel.id === result.panel.id;
        }),
        stateRegulations: stateRegulations,
        results: {
            components: __spreadArrays(result.results.components, [
                index_1.deriveTotalAflatoxinsResult({
                    components: result.results.components,
                    parameters: result.instrumentUsed.instrumentParameters.filter(function (_a) {
                        var panel = _a.panel;
                        return panel.id === result.panel.id;
                    }),
                }),
            ]),
        },
        moistureContentPercentage: moistureContentPercentage,
        density: density,
        isSolid: isSolid,
        amountPerPackage: amountPerPackage,
        amountPerServing: amountPerServing,
    });
    var chemResRows = utils_1.defaultBuildRows({
        parameters: filterMycotoxins(result.instrumentUsed.instrumentParameters.filter(function (_a) {
            var panel = _a.panel;
            return panel.id === result.panel.id;
        })),
        stateRegulations: stateRegulations,
        results: {
            components: __spreadArrays(result.results.components, [
                index_1.deriveSpinosadResult({
                    components: result.results.components,
                    parameters: result.instrumentUsed.instrumentParameters.filter(function (_a) {
                        var panel = _a.panel;
                        return panel.id === result.panel.id;
                    }),
                }),
                index_1.derivePyrethrinResult({
                    components: result.results.components,
                    parameters: result.instrumentUsed.instrumentParameters.filter(function (_a) {
                        var panel = _a.panel;
                        return panel.id === result.panel.id;
                    }),
                }),
            ]),
        },
        moistureContentPercentage: moistureContentPercentage,
        density: density,
        isSolid: isSolid,
        amountPerPackage: amountPerPackage,
        amountPerServing: amountPerServing,
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(PanelCard_1.default, __assign({}, rest, { panelName: "Mycotoxins", instrumentName: result.instrumentUsed.name, method: result.panel.standardOperatingProcedures[0].name, passFailResult: determineChemResPassFailResult(mycotoxinRows), table: React.createElement(ResultsTable_1.default, { columns: columns_1.mycotoxinColumnsFactory({ addPassFail: rest.addPassFail }), rows: mycotoxinRows }) })),
        React.createElement(PanelCard_1.default, __assign({}, rest, { panelName: "Chemical Residue", instrumentName: result.instrumentUsed.name, method: result.panel.standardOperatingProcedures[0].name, passFailResult: determineChemResPassFailResult(chemResRows), table: React.createElement(ResultsTable_1.default, { columns: columns_1.chemResColumnsFactory({ addPassFail: rest.addPassFail }), rows: R.splitAt(CHEMICAL_RESIDUE_ROW_SPLIT, chemResRows)[0] }) })),
        React.createElement(PanelCard_1.default, __assign({}, rest, { panelName: "Chemical Residue", instrumentName: result.instrumentUsed.name, method: result.panel.standardOperatingProcedures[0].name, passFailResult: determineChemResPassFailResult(chemResRows), table: React.createElement(ResultsTable_1.default, { columns: columns_1.chemResColumnsFactory({ addPassFail: rest.addPassFail }), rows: R.splitAt(CHEMICAL_RESIDUE_ROW_SPLIT, chemResRows)[1] }) }))));
};
exports.default = ChemicalResidueCard;
//# sourceMappingURL=index.js.map